import React, { useState, useEffect } from "react";
import Table from "../../Tables/Table";
import Popup from "../../Popups/Popup";
import { ApplicationStatusses, IAppChangeStatusModel, ApplicationStatussesTranslations } from "../../TradeApplication/types";
import { ITradeApplication } from "../../TradeApplication/types";
import { DocumentTypes, IDocumentModel } from "../../Common/types";
import { ApplicationDetails } from "../../TradeApplication/components/ApplicationDetails";
import { TradeApplicationChangeStatus } from "../../Views/MyActivity/baseComponent/remote";
import { TradeStatus } from "../../enums/TradeStatus";
import Loading from "../../Ui/Loading";
import GenerateAndSign from "../../Common/Document/GenerateAndSign";
import AccountInfo from "../../Profile/AccountInfo";
import DocumentsTable from "../../Tables/DocumentsTable";
import { GeneratePartyDesicionProtocol, FinishPartyDesicion } from "../../TradeApplication/remote";
import { useSignal } from "react-signal-slot";
import { TableMode } from "../../enums/TableTypes";

interface IPropsType {
    applications: ITradeApplication[];
    documents?: IDocumentModel[]; // Новый пропс для документов лота
    renderDocName: (rowData: IDocumentModel) => any;
    lotId?: Number;
    page?: string;
    tradeStatusId?: Number;
}

const ApplicationsForMyActivity = (props: IPropsType) => {
    const [isOpenDeclineReasonPopup, setIsOpenDeclineReasonPopup] = useState(false);
    const [applications, setApplications] = useState<ITradeApplication[]>(props.applications);
    const [declineReason, setDeclineReason] = useState<string | null>(null);
    const [showAllDocsMap, setShowAllDocsMap] = useState<{ [key: number]: boolean }>({});
    const [isLoading, setIsLoading] = useState(false);
    const [newDeclineReason, setNewDeclineReason] = useState<string | null>();
    const [isOpenNewDeclineReasonPopup, setIsOpenNewDeclineReasonPopup] = useState(false);
    const [currentApplicationId, setCurrentApplicationId] = useState<number | null>(null);
    const [protocol, setProtocol] = useState<IDocumentModel | null>(null);
    const [allowProtocolGeneration, setAllowProtocolGeneration] = useState<boolean | null>(null);

    const lotId = props.lotId;
    const page = props.page;
    const tradeStatusId = props.tradeStatusId;

    useEffect(() => {
        setApplications(props.applications);
    }, [props.applications]);

    // Инициализация протокола и allowProtocolGeneration
    useEffect(() => {
        if (applications) {
            // Ищем протокол в applications или documents
            let foundProtocol = findDocumentByType(DocumentTypes.PartyDecisionProtocol);
            if (!foundProtocol && props.documents) {
                foundProtocol = props.documents.find(doc => doc.DocumentTypeId === DocumentTypes.PartyDecisionProtocol) || null;
            }
            setProtocol(foundProtocol);

            // Проверяем, можно ли генерировать протокол
            const canGenerateProtocol = !applications.some(app =>
                app.ApplicationStatusId === ApplicationStatusses.WaitingForConfirmation
            );
            setAllowProtocolGeneration(canGenerateProtocol && !foundProtocol);
        }
    }, [applications, props.documents]);

    const signal = useSignal();

    const findDocumentByType = (documentType) => {
        if (!applications || !applications.length) return null;
        for (const application of applications) {
            if (application.Documents && application.Documents.length) {
                const foundDoc = application.Documents.find(doc => doc.DocumentTypeId === documentType);
                if (foundDoc) return foundDoc;
            }
        }
        return null;
    };

    const handleDeclineReason = (rowData) => {
        setIsOpenDeclineReasonPopup(true);
        setDeclineReason(rowData.DeclineReason);
    };

    const handleNewDeclineReason = (rowData) => {
        setIsOpenNewDeclineReasonPopup(true);
        setNewDeclineReason(rowData.DeclineReason);
    };

    const changeStatus = (changesModel, newStatus, applicationId) => {
        setIsLoading(true);
        TradeApplicationChangeStatus(changesModel)
            .then((result) => {
                console.log("Changes for application status:", result.UpdatedItem);
                setAllowProtocolGeneration(result.UpdatedItem.AllowProtocolGeneration && !protocol);
                setIsLoading(false);
                if (result.Success) {
                    setApplications((prev) =>
                        prev.map((app) =>
                            app.TradeApplicationId === applicationId
                                ? {
                                    ...app,
                                    ApplicationStatusId: result.UpdatedItem.Status || newStatus,
                                    ApplicationStatus:
                                        ApplicationStatussesTranslations[result.UpdatedItem.Status] ||
                                        ApplicationStatussesTranslations[newStatus],
                                    DeclineReason:
                                        newStatus === ApplicationStatusses.Declined
                                            ? result.UpdatedItem.StatusMessage || changesModel.Reason
                                            : null,
                                }
                                : app
                        )
                    );
                }
            })
            .catch((error) => {
                console.error("Error changing application status:", error);
                setApplications((prev) =>
                    prev.map((app) =>
                        app.TradeApplicationId === applicationId
                            ? {
                                ...app,
                                ApplicationStatusId: app.ApplicationStatusId,
                                ApplicationStatus: ApplicationStatussesTranslations[app.ApplicationStatusId],
                            }
                            : app
                    )
                );
                setIsLoading(false);
                alert("Ошибка. Попробуйте снова.");
            });
    };

    const acceptApplication = (applicationId) => {
        setIsLoading(true);
        const approvedStatus = ApplicationStatusses.Approved;
        const changesModel: IAppChangeStatusModel = {
            Id: applicationId,
            Reason: null,
            Status: approvedStatus,
        };
        changeStatus(changesModel, approvedStatus, applicationId);
    };

    const declineApplication = (applicationId: number, reason: string) => {
        setIsOpenNewDeclineReasonPopup(false);
        setIsLoading(true);
        const declinedStatus = ApplicationStatusses.Declined;
        const changesModel: IAppChangeStatusModel = {
            Id: applicationId,
            Reason: reason,
            Status: declinedStatus,
        };
        changeStatus(changesModel, declinedStatus, applicationId);
    };

    const handleDeclineApplication = (applicationId) => {
        setCurrentApplicationId(applicationId);
        setNewDeclineReason("");
        setIsOpenNewDeclineReasonPopup(true);
    };

    const toggleShowAllDocs = (applicationId: number) => {
        console.log(`Тоггл показа документов для заявки ${applicationId}`);
        setShowAllDocsMap((prev) => ({
            ...prev,
            [applicationId]: !prev[applicationId],
        }));
    };

    const onGenerateProtocol = (callback) => {
        setIsLoading(true);
        GeneratePartyDesicionProtocol(lotId).then((result) => {
            console.log("Generated protocol result:", result);
            if (result.Success) {
                const newProtocol = result.UpdatedItem;
                setProtocol(newProtocol);
                setAllowProtocolGeneration(false); // Скрываем кнопку

                // Временно добавляем протокол к первой заявке
                setApplications((prev) =>
                    prev.map((app, index) => {
                        if (index === 0) {
                            return {
                                ...app,
                                Documents: [...(app.Documents || []), newProtocol],
                            };
                        }
                        return app;
                    })
                );

                signal("protocolPartyCreated", {
                    Id: newProtocol.Id,
                    Name: newProtocol.Name,
                    DocumentLink: `/Document/Details/${newProtocol.DocumentId}`,
                    DocumentTypeId: newProtocol.DocumentTypeId,
                    AccountName: AccountInfo.Fio,
                    Comment: newProtocol.Comment,
                    MimeType: newProtocol.MimeType,
                });
                callback(null);
            } else {
                console.error("Protocol generation failed:", result.Error);
                callback(result.Error);
            }
            setIsLoading(false);
        }).catch((error) => {
            console.error("Error generating protocol:", error);
            callback(error);
            setIsLoading(false);
        });
    };

    const onSignProtocol = (callback) => {
        setIsLoading(true);
        FinishPartyDesicion(lotId).then((result) => {
            setIsLoading(false);
            window.location.reload();
        }).catch((error) => {
            console.error("Error signing protocol:", error);
            callback(error);
            setIsLoading(false);
        });
    };

    // Объединяем все документы для DocumentsTable
    const allDocuments = [
        ...applications?.flatMap((app) => app.Documents || []) || [],
        ...(protocol ? [protocol] : []),
    ];

    console.log("applications", applications);
    console.log("protocol", protocol);
    console.log("allDocuments", allDocuments);
    console.log("allowProtocolGeneration", allowProtocolGeneration);

    return (
        <>
            {isLoading && <Loading />}
            <Table
                data={applications || props.applications}
                columns={[
                    { name: "TradeApplicationId", title: "№" },
                    { name: "Participant", title: "ФИО участника" },
                    { name: "Comment", title: "Комментарий" },
                    {
                        name: "Documents",
                        title: "Документы",
                        body: (rowData) => {
                            if (!Array.isArray(rowData.Documents) || rowData.Documents.length === 0) {
                                return <span>Нет документов</span>;
                            }
                            const isShowAll = showAllDocsMap[rowData.TradeApplicationId] || false;
                            return (
                                <>
                                    {rowData.Documents.length > 2 ? (
                                        isShowAll ? (
                                            <>
                                                {rowData.Documents.map((doc) => props.renderDocName(doc))}
                                                <button
                                                    className="defaultSmallBlackBorderButton"
                                                    onClick={() => toggleShowAllDocs(rowData.TradeApplicationId)}
                                                >
                                                    Скрыть
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                {rowData.Documents.slice(0, 2).map((doc) => props.renderDocName(doc))}
                                                <button
                                                    className="defaultSmallBlackBorderButton"
                                                    onClick={() => toggleShowAllDocs(rowData.TradeApplicationId)}
                                                >
                                                    Показать все ({rowData.Documents.length - 2})
                                                </button>
                                            </>
                                        )
                                    ) : (
                                        rowData.Documents.map((doc) => props.renderDocName(doc))
                                    )}
                                </>
                            );
                        },
                    },
                    {
                        name: "ApplicationStatus",
                        title: "Статус",
                        body: (rowData) => {
                            if (rowData.ApplicationStatusId === ApplicationStatusses.Declined) {
                                return (
                                    <div>
                                        <div>
                                            <span style={{ color: "red" }}>{rowData.ApplicationStatus}</span>
                                        </div>
                                        <div>
                                            <span
                                                style={{ color: "blue", cursor: "pointer" }}
                                                onClick={() => handleDeclineReason(rowData)}
                                            >
                                                Причина
                                            </span>
                                        </div>
                                    </div>
                                );
                            } else if (rowData.ApplicationStatusId === ApplicationStatusses.Approved) {
                                return <span style={{ color: "#16bc27" }}>{rowData.ApplicationStatus}</span>;
                            } else if (rowData.ApplicationStatusId === ApplicationStatusses.WaitingForConfirmation) {
                                return <span style={{ color: "#d19301" }}>{rowData.ApplicationStatus}</span>;
                            } else {
                                return <span>{rowData.ApplicationStatus}</span>;
                            }
                        },
                    },
                    {
                        name: "Actions",
                        title: "Действия",
                        body: (rowData) => {
                            if (
                                (rowData.ApplicationStatusId === ApplicationStatusses.New ||
                                    rowData.ApplicationStatusId === ApplicationStatusses.WaitingForConfirmation) &&
                                tradeStatusId === TradeStatus.ApplicationProcessing
                            ) {
                                return (
                                    <>
                                        <div>
                                            <button
                                                className="defaultSmallBlackBorderButton mb-3"
                                                onClick={() => acceptApplication(rowData.TradeApplicationId)}
                                                disabled={isLoading}
                                            >
                                                Принять
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                className="defaultSmallBlackBorderButton"
                                                onClick={() => handleDeclineApplication(rowData.TradeApplicationId)}
                                                disabled={isLoading}
                                            >
                                                Отклонить
                                            </button>
                                        </div>
                                    </>
                                );
                            }
                        },
                    },
                ]}
                key={`${applications?.length || 0}-${Object.values(showAllDocsMap).join("-")}`}
            />
            {page === "LotsWithMyBets" && props.tradeStatusId === TradeStatus.AllowAcceptance &&
                <ApplicationDetails lotId={lotId} loadApp={true}/>}
            
            {page === "MyLots" && allowProtocolGeneration !== null && props.tradeStatusId === TradeStatus.ApplicationProcessing && (
                <div className="protocol-container" style={{ width: '100%' }}>
                    <GenerateAndSign
                        Doc={protocol}
                        onGenerate={onGenerateProtocol}
                        onSigned={onSignProtocol}
                        Thumbprint={AccountInfo.Thumbprint} 
                    />
                </div>
            )}
            <Popup
                isOpen={isOpenDeclineReasonPopup}
                close={() => setIsOpenDeclineReasonPopup(false)}
                head={{ title: "Причина отказа в подтверждении заявки", description: declineReason }}
            />
            <Popup
                isOpen={isOpenNewDeclineReasonPopup}
                close={() => {
                    setIsOpenNewDeclineReasonPopup(false);
                    setNewDeclineReason("");
                    setCurrentApplicationId(null);
                }}
                head={{ title: "Укажите причину отказа" }}
                body={
                    <div>
                        <textarea
                            value={newDeclineReason}
                            onChange={(e) => setNewDeclineReason(e.target.value)}
                            placeholder="Введите причину отказа"
                            style={{ width: "100%", minHeight: "100px", marginBottom: "10px" }}
                        />
                        <div style={{ display: "flex", gap: "10px" }}>
                            <button
                                className="defaultSmallBlackBorderButton"
                                onClick={() => {
                                    if (currentApplicationId && newDeclineReason.trim()) {
                                        declineApplication(currentApplicationId, newDeclineReason);
                                    } else {
                                        alert("Пожалуйста, введите причину отказа.");
                                    }
                                }}
                                disabled={isLoading}
                            >
                                Подтвердить
                            </button>
                            <button
                                className="defaultSmallBlackBorderButton"
                                onClick={() => {
                                    setIsOpenNewDeclineReasonPopup(false);
                                    setNewDeclineReason("");
                                    setCurrentApplicationId(null);
                                }}
                            >
                                Отмена
                            </button>
                        </div>
                    </div>
                }
            />
        </>
    );
};

export default ApplicationsForMyActivity;